


































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "apprelease/appstore";

  appstores: any = {
    appstore: "苹果应用商店",
    huawei: "华为应用市场",
    qq: "腾讯应用宝",
    vivo: "vivo应用商店",
    xiaomi: "小米应用商店",
    honor:"荣耀应用商店"
  };
  
  // 操作搜索栏的展开和折叠
  isFlag = false;

  apps: any = {
    yuyuesports: "羽约运动",
    changguan: "羽约场馆"
  };

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "应用", scopedSlots: { customRender: "app" } },
    { title: "应用市场", scopedSlots: { customRender: "app_code" } },
    { title: "获取时间", dataIndex: "created_time" },
    { title: "版本号", dataIndex: "version_no" },
    { title: "线上日期", dataIndex: "version_date" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
